<template>
  <v-row justify="center">
    <v-dialog v-model="openDialog" persistent :max-width="sizeDialog">
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ titleDialog }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <slot></slot>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" text @click="emitOnCloseDialog">
            FECHAR
          </v-btn>
          <v-btn color="green darken-1" text @click="emitOnActionDialog">
            CONCLUIR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    openDialog: Boolean,
    sizeDialog: String,
    titleDialog: String
  },

  methods: {
    emitOnCloseDialog() {
        this.$emit("dialog-close");
    },

    emitOnActionDialog() {
        this.$emit("dialog-action");
    }
  }
};
</script>
